"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Extended class to override the de-serialization behavior (fromJson)
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */
var GetDisplayableFeedbackQuestionnaireResponse = /*#__PURE__*/function (_GetDisplayableFeedba) {
  (0, _inherits2["default"])(GetDisplayableFeedbackQuestionnaireResponse, _GetDisplayableFeedba);
  var _super = _createSuper(GetDisplayableFeedbackQuestionnaireResponse);
  function GetDisplayableFeedbackQuestionnaireResponse() {
    (0, _classCallCheck2["default"])(this, GetDisplayableFeedbackQuestionnaireResponse);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(GetDisplayableFeedbackQuestionnaireResponse, null, [{
    key: "fromJson",
    value: function fromJson(data) {
      return GetDisplayableFeedbackQuestionnaireResponse.clone(data);
    }
  }]);
  return GetDisplayableFeedbackQuestionnaireResponse;
}(_coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireResponse); // Register concrete types for serialization
_ihmJsCoralClient.modelRegistrySingleton.registerType(GetDisplayableFeedbackQuestionnaireResponse);
var _default = exports["default"] = GetDisplayableFeedbackQuestionnaireResponse;
//# sourceMappingURL=GetDisplayableFeedbackQuestionnaireResponse.js.map